import axios from "axios";
import {getField, updateField} from "vuex-map-fields";


export default {
  namespaced: true,
  state: {
    rights: [],
    fetched: false
  },
  getters:{
    getField, //vuex-map-fields
  },
  mutations: {
    setRights(state, rights) {
      state.rights = rights;
      state.fetched = true;
    },
  },
  actions: {
    getRights({ commit, state, dispatch }){
      return axios.get(this._vm.$apiURL+'/rights')
        .then(response => {
          commit('setRights', response.data || null);
        })
        .catch(error => {
            dispatch('common/showError', {'error': error}, {root:true});
        });
    }
  }
}



